export const copyTextToClipboard = async (
  text: string,
  onSuccess?: () => void,
  onFailure?: () => void
) => {
  try {
    await navigator.clipboard.writeText(text)
    if (onSuccess) {
      onSuccess()
    }
  } catch (err) {
    console.error('Failed to copy: ', err)
    if (onFailure) {
      onFailure()
    }
  }
}
